import * as React from 'react';
import Timer from 'lib/Timer';

// This component exists simply to mark that the stream section
// list data has fully loaded from the Apollo server.

const GROUP_UUIDS_ALREADY_LOADED: { [groupUuid: string]: boolean } = {};

export const StreamSectionListLoadTimerConstants = {
  LAST_CHANGE: 'app_started_or_user_navigated',
  TRANSITION_KEY_FIRST_GROUP_LOAD: 'stream_list_from_group_cold',
  TRANSITION_KEY_SUBSEQUENT_LOAD: 'stream_list_from_group_warm',
};

type Props = {
  groupUuid: string;
};

export default class StreamSectionListLoadTimer extends React.Component<Props> {
  componentDidMount() {
    const groupWasAlreadyLoaded = !!GROUP_UUIDS_ALREADY_LOADED[this.props.groupUuid];
    const transitionKey = groupWasAlreadyLoaded
      ? StreamSectionListLoadTimerConstants.TRANSITION_KEY_SUBSEQUENT_LOAD
      : StreamSectionListLoadTimerConstants.TRANSITION_KEY_FIRST_GROUP_LOAD;
    Timer.markChange(transitionKey, StreamSectionListLoadTimerConstants.LAST_CHANGE);
    if (!groupWasAlreadyLoaded) {
      GROUP_UUIDS_ALREADY_LOADED[this.props.groupUuid] = true;
    }
  }

  render() {
    return null;
  }
}
